import { render, staticRenderFns } from "./zyjgscarrecord.vue?vue&type=template&id=977f1f18&scoped=true"
import script from "./zyjgscarrecord.vue?vue&type=script&lang=js"
export * from "./zyjgscarrecord.vue?vue&type=script&lang=js"
import style0 from "./zyjgscarrecord.vue?vue&type=style&index=0&id=977f1f18&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "977f1f18",
  null
  
)

export default component.exports